<template>
  <div class="container">
    <div class="columns box-title is-12">
      <div class="column is-6">
        <h4 class="has-text-left">
          <i class="fal fa-upload"></i>
          {{ $t("corporateEmployee.page_title") }}
          <span class="countTotal">({{ count }})</span>
        </h4>
      </div>
      <div class="column is-6">
        <vs-button @click="exportToExcel" success style="border-radius: 4px !important; float: right;"
                   :loading="isExporting">
          Export Excel
        </vs-button>
      </div>
    </div>
    <div class="box">
      <div class="columns">
        <div class="column is-2">
          <div class="field">
            <div class="control">
              <label style="margin-right: 10px; " class="label">
                {{ $t("corporateEmployee.search") }}:
              </label>
              <input
                class="input"
                type="text"
                style="height: 34px"
                name="searchItem"
                :placeholder="$t('corporateEmployee.search_placeholder')"
                v-model="searchItem"
                @keyup.enter="FilterBySearch()"
              />
            </div>
          </div>
        </div>
        <div class="column is-2">
          <div class="control">
            <label class="label">{{ $t("corporateEmployee.from_date") }}:</label>
            <date-picker
              format="DD/MM/YYYY"
              value-type="YYYY-MM-DD"
              type="date"
              v-model="start_date"
              :disabled-date="disabledAfterToday"
              :clearable="false"
              name="start_date"
            ></date-picker>
          </div>
        </div>
        <div class="column is-2">
          <div class="control">
            <label class="label">{{ $t("common.ຫາວັນທີ") }}:</label>
            <date-picker
              format="DD/MM/YYYY"
              value-type="YYYY-MM-DD"
              type="date"
              v-model="end_date"
              :disabled-date="disabledAfterToday"
              :clearable="false"
              name="end_date"
            ></date-picker>
          </div>
        </div>
        <div class="column is-2">
          <div class="control" style="display: flex; align-items: flex-end; height: 100%;">
            <vs-button style=" margin-bottom: 0" circle icon flat @click="FilterBySearch()">
              <i class="fal fa-search"></i>
            </vs-button>
          </div>
        </div>
      </div>
    </div>
    <div class="center fit-width">
      <vs-table ref="table">
        <template #thead>
          <vs-tr>
            <vs-th>{{ $t("corporateEmployee.no") }}</vs-th>
            <vs-th>{{ $t("corporateEmployee.uploader_name") }}</vs-th>
            <vs-th>{{ $t("corporateEmployee.employee_tel") }}</vs-th>
            <vs-th>{{ $t("corporateEmployee.store_name") }}</vs-th>
            <vs-th>{{ $t("corporateEmployee.total_count") }}</vs-th>
            <vs-th>{{ $t("corporateEmployee.pre_order_bills") }}</vs-th>
            <vs-th>{{ $t("corporateEmployee.received_at_branch") }}</vs-th>
            <vs-th>{{ $t("corporateEmployee.upload_month") }}</vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr
            :key="index"
            :data="report"
            v-for="(report, index) in $vs.getPage(reports, page, max)">
            <vs-td>{{ index + 1 }}</vs-td>
            <vs-td>{{ report.employee ? report.employee.name : "-" }}</vs-td>
            <vs-td>{{ report.employee ? report.employee.user_tel : "-" }}</vs-td>
            <vs-td>{{ report.customer_store_name }}</vs-td>
            <vs-td>{{ report.total_uploaded_count }}</vs-td>
            <vs-td>{{ report.pre_order_count }}</vs-td>
            <vs-td>{{ report.normal_order_count }}</vs-td>
            <vs-td>{{ moment(report.uploaded_at).format("MM/YYYY") }}</vs-td>
          </vs-tr>
        </template>
        <template #footer>
          <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="offset"
                      @paginate="FetchData"></pagination>
          <Loading v-if="isLoading" />
        </template>
      </vs-table>
    </div>
  </div>
</template>
<script>
import Loading from "@/views/Loading";
import pagination from "@/Plugins/Paginations/Pagination";
import * as helper from "@/Helpers/GetValue";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { FormatDateTimeBeforeSendToServer } from "@/Helpers/Format";

export default {
  components: {
    Loading,
    pagination,
    DatePicker
  },

  data: () => ({
    page: 1,
    max: 10,
    isLoading: true,
    isExporting: false,
    status: "",
    reports: [],
    searchItem: "",
    oldVal: "",
    start_date: "",
    end_date: "",
    loading: false,
    // Pagination
    count: 0,
    offset: 10,
    limit_page: 10,
    pagination: {}
  }),
  watch: {
    "searchItem": function(value) {
      if (value === "") {
        this.FetchData();
      }
    },
    "start_date": function(value) {
      localStorage.setItem("upload_reports_start_date", value);
    },
    "end_date": function(value) {
      localStorage.setItem("upload_reports_end_date", value);
    }
  },
  methods: {
    disabledAfterToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today;
    },

    FetchData() {
      this.isLoading = true;
      this.fetchReportsResponse().then((res) => {
        setTimeout(() => {
          this.reports = res.data.data;
          this.count = res.data.total;
          this.pagination = res.data;
          this.isLoading = false;
          this.oldVal = "";
        }, 300);
      }).catch(() => {
        this.isLoading = false;
      });
    },

    fetchReportsResponse(options = {}) {
      const { current_page, per_page } = options;
      return this.$http.get("v2/auth/store/management/pre-shipment/employee-upload-reports", {
        params: {
          q: this.searchItem,
          start_date: this.start_date,
          end_date: this.end_date,
          page: current_page ?? this.pagination.current_page,
          limit: per_page ?? this.limit_page
        }
      });
    },
    FilterBySearch() {
      // Reset to page 1 when searching
      if (this.pagination.current_page !== 1) {
        this.pagination.current_page = 1;
      }

      // Save current date values to localStorage
      localStorage.setItem("upload_reports_start_date", this.start_date);
      localStorage.setItem("upload_reports_end_date", this.end_date);

      helper.GetOldValueOnInput(this);
      this.FetchData();
    },

    BtnLoading() {
      return this.$vs.loading({
        target: this.$refs.table,
        scale: "1",
        background: "primary",
        opacity: 1,
        color: "#195BFF"
      });
    },

    exportToExcel() {
      if (this.isExporting) {
        return;
      }
      this.isExporting = true;

      // Generate unique exportId
      const exportId = uuidv4();
      const hasStartDate = !!this.start_date;
      const hasEndDate = !!this.end_date;

      const startDate = hasStartDate ? FormatDateTimeBeforeSendToServer(this.start_date) : null;
      const endDate = hasEndDate ? FormatDateTimeBeforeSendToServer(this.end_date) : null;

      const exportPrefixFilename = hasStartDate && hasEndDate
        ? this.$t("corporateEmployee.export_date_range", { start: startDate, end: endDate })
        : this.$t("common.ທັງໝົດ");

      this.$http.post("v2/auth/store/management/exports/pre-shipment/employee-upload-reports",
        {
          q: this.searchItem,
          start_date: this.start_date,
          end_date: this.end_date,
          export_id: exportId
        },
        {
          responseType: "blob",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          }
        }).then((response) => {
        const fileUrl = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement("a");
        fileLink.href = fileUrl;
        fileLink.setAttribute("download", `${this.$t("corporateEmployee.export_filename", { range: exportPrefixFilename })}.xlsx`);
        document.body.appendChild(fileLink);
        fileLink.click();
        document.body.removeChild(fileLink);
      }).catch(() => {
        this.$vs.notification({
          title: "Error",
          text: "Failed to export data",
          color: "danger"
        });
      }).finally(() => {
        this.isExporting = false;
      });
    }
  },
  created() {
    // Check localStorage for saved dates
    const savedStartDate = localStorage.getItem("upload_reports_start_date");
    const savedEndDate = localStorage.getItem("upload_reports_end_date");

    // Use saved dates if they exist, otherwise use current date
    this.start_date = savedStartDate || moment(new Date()).format("YYYY-MM-DD");
    this.end_date = savedEndDate || moment(new Date()).format("YYYY-MM-DD");

    this.FetchData();
  }
};
</script>
<style lang="scss" scoped>
.container {
  margin-top: 40px;

  .title-login {
    font-size: 20px;
    color: $primary-color;
  }
}

.fit-width {
  white-space: nowrap;
}

.vs-table__td,
.vs-table__th {
  vertical-align: middle !important;
  white-space: nowrap !important;
  width: 1px !important;
}
</style>
